import { lazy, type ComponentType } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { notOnFileRetailerAccessControl } from '../access-control/connectedStoresAccess.configuration'
import Toasts from '../toasts'

// Not on File (Partner Scope)
const ConnectedStoresNotOnFilePartnerPage = lazy(() => import('../pages/not-on-file-retailer'))
const ConnectedStoresNotOnFilePartnerDetailsPage = lazy(
  () => import('../pages/not-on-file-retailer/details')
)

export const connectedStoresPartnerRouter = (
  <DomainRoute route="app-partner-scope-connected-stores">
    <Toasts />
    <DashSwitch>
      <DomainRoute
        exact
        route="app-partner-scope-connected-stores-not-on-file"
        component={ConnectedStoresNotOnFilePartnerPage as ComponentType<any>}
        accessControl={notOnFileRetailerAccessControl}
      />
      <DomainRoute
        exact
        route="app-partner-scope-connected-stores-not-on-file-details"
        component={ConnectedStoresNotOnFilePartnerDetailsPage as ComponentType<any>}
        accessControl={notOnFileRetailerAccessControl}
      />
    </DashSwitch>
  </DomainRoute>
)
